export default class betoniAttrDataClass {
  attrId;
  keikkaId;
  tarjousId;
  keikkaBetoniId;
  keikkaBetoniAttrId;
  attrNimike;
  attrSelite;
  attrHelpId;
  keikkaBetoniAttrComment = null;
  constructor(sqlData = null) {
    if (sqlData) {
      this.attrId = sqlData.attrId || null;
      this.keikkaId = sqlData.keikkaId || null;
      this.tarjousId = sqlData.tarjousId || null;
      this.keikkaBetoniAttrId = sqlData.keikkaBetoniAttrId || null;
      this.attrNimike = sqlData.attrNimike || null;
      this.attrSelite = sqlData.attrSelite || null;
      this.attrHelpId = sqlData.attrHelpId || null;
      this.keikkaBetoniId = sqlData.keikkaBetoniId || null;
      this.keikkaBetoniAttrComment = sqlData.keikkaBetoniAttrComment || null;
    } else {
      this.init();
    }
  }
  init() {
    // Initialize all properties to null or default values
    // This is useful when creating a new instance without data
    this.attrId = null;
    this.keikkaId = null;
    this.tarjousId = null;
    this.keikkaBetoniAttrId = null;
    this.attrNimike = null;
    this.attrSelite = null;
    this.attrHelpId = null;
    this.keikkaBetoniAttrComment = null;
  }
}
